/**
 * Toggle Theme
 *
 */
import React, { useContext } from 'react'
import { connect } from 'react-redux'
import Fa from './../Fa'
import { setKernelTheme } from '../../actions/kernel.theme'
import { OrgContext } from '../../context/Organizacion'

const ToggleTheme = (props) => {
  const org = useContext(OrgContext)

  /**
   * toggleTheme
   */
  const toggleTheme = () => {
    props.setTheme(props.theme.name === 'light' ? 'dark' : 'light', org.opciones)
  }

  return (
    <div onClick={() => toggleTheme()} style={{ display: 'flex', cursor: 'pointer' }}>
      <Fa
        style={{ fontSize: 30, color: props.theme.name === 'dark' ? '#ffd15d': props.theme.values.colors.icon }}
        name='moon-o'
      />
    </div>
  )
}

const connected = connect(
  state => ({ theme: state.theme }),
  dispatch => ({
    setTheme: (name, values) => dispatch(setKernelTheme(name, values))
  })
)(ToggleTheme)

export default connected
